import { Web3DPlugin } from '@technology/web3d';
import type { Api } from '@technology/web3d/dist/esnext/Api.js';
import type { PathNavigationPluginOptions } from './path-navigation-plugin.types';
import { PathNavigationTool } from './path-navigation-tool';

export class PathNavigationPlugin extends Web3DPlugin {
  private tool: PathNavigationTool | undefined;

  constructor(private readonly options: PathNavigationPluginOptions = {}) {
    super();
  }

  public get name(): string {
    return 'pathNavigation';
  }

  public set api(api: Api) {
    this.tool = new PathNavigationTool(api);
    this.tool.inertiaEnabled = this.options.inertiaEnabled ?? true;
    api.toolManager.addTool(this.tool);
  }

  public getTool(): PathNavigationTool | undefined {
    return this.tool;
  }
}
